<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsReviewContactInfoTitle')" [showCloseButton]="false" (closeModal)="onUpdateLater()">
    <div modal-content>
      <p id="review-contact-info-message" class="text-ld-neutral-500 text-base leading-relaxed m-0">
        {{ t('modalsReviewContactInfoMessage') }}
      </p>
    </div>
    <div modal-footer>
      <button
        id="review-contact-info-update-later-btn"
        type="button"
        class="btn-outline-ld-purple"
        (click)="onUpdateLater()"
      >
        {{ t('modalsReviewContactInfoUpdateLaterButton') }}
      </button>
      <button id="review-contact-info-continue-btn" type="button" class="btn-primary-ld-purple" (click)="onContinue()">
        {{ t('commonButtonsContinue') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
